/**
 * Meta Pixel (catálogo de vehículos). `content_ids` DEBE ser el `id` del vehículo
 * (placa normalizada, igual a `<g:id>` del feed de Meta; envío de la placa a Meta aprobado por WCAR). No-op si el Pixel no cargó.
 */
import { IS_SCREENS_MODE } from "../config/appMode";
import { META_PIXEL_ID } from "../config/env";

type Fbq = (...args: unknown[]) => void;

// En las pantallas de las sedes no hay Pixel: sin `init` el loader de index.html no envía nada.
const _fbq = (): Fbq | undefined => (IS_SCREENS_MODE ? undefined : (window as unknown as { fbq?: Fbq }).fbq);

// Misma normalización que el feed del backend: mayúsculas, sin espacios ni guiones.
const _placa = (p: string) => p.toUpperCase().replace(/[^A-Z0-9]/g, "");
const _key = (id: string) => `pixel_placa_${id}`;

export function pixelViewContent(vehiculoId: string, placa: string | undefined, value?: number): void {
    if (!placa) return;
    const contentId = _placa(placa);
    // shortcut: el Lead (otra pantalla, solo conoce el id de BD) lee la placa de aquí; sin ficha previa no hay Lead.
    try {
        sessionStorage.setItem(_key(vehiculoId), contentId);
    } catch {}
    _fbq()?.("track", "ViewContent", { content_type: "vehicle", content_ids: [contentId], value, currency: "COP" });
}

export function pixelLead(vehiculoId: string): void {
    let contentId: string | null = null;
    try {
        contentId = sessionStorage.getItem(_key(vehiculoId));
    } catch {}
    if (!contentId) return;
    _fbq()?.("track", "Lead", { content_type: "vehicle", content_ids: [contentId], currency: "COP" });
}

/** Inicializa el Pixel y registra el PageView inicial. Llamar una sola vez, antes del primer render. */
export function initMetaPixel(): void {
    _fbq()?.("init", META_PIXEL_ID);
    _fbq()?.("track", "PageView");
}
